import { render, staticRenderFns } from "./TaxAccounts.vue?vue&type=template&id=eb74ed48&scoped=true&"
import script from "./TaxAccounts.vue?vue&type=script&lang=js&"
export * from "./TaxAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TaxAccounts.vue?vue&type=style&index=0&id=eb74ed48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb74ed48",
  null
  
)

export default component.exports